import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "nes-container with-title" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "Fund / Cancel / Lock Funding", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Choose reward:", -1)
const _hoisted_4 = { class: "nes-select mb-5" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "rewardA" }, "Reward A", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "rewardB" }, "Reward B", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = { class: "mb-5" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Selected reward is ")
const _hoisted_10 = { class: "inline-block bg-yellow-200" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "flex mb-5" }
const _hoisted_13 = { class: "nes-field mr-5 flex-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "baseRate" }, "Base rate (tokens/gem/s):", -1)
const _hoisted_15 = { class: "nes-field flex-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "denominator" }, "Denominator (divides all rates):", -1)
const _hoisted_17 = { class: "flex mb-5" }
const _hoisted_18 = { class: "nes-field mr-5 flex-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", { for: "t1RewardRate" }, "Tier 1 reward rate (tokens/gem/s):", -1)
const _hoisted_20 = { class: "nes-field flex-1" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "t1RequiredTenure" }, "Tier 1 required tenure (sec):", -1)
const _hoisted_22 = { class: "flex mb-5" }
const _hoisted_23 = { class: "nes-field mr-5 flex-1" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "t2RewardRate" }, "Tier 2 reward rate (tokens/gem/s):", -1)
const _hoisted_25 = { class: "nes-field flex-1" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", { for: "t2RequiredTenure" }, "Tier 2 required tenure (sec):", -1)
const _hoisted_27 = { class: "flex mb-5" }
const _hoisted_28 = { class: "nes-field mr-5 flex-1" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { for: "t3RewardRate" }, "Tier 3 reward rate (tokens/gem/s):", -1)
const _hoisted_30 = { class: "nes-field flex-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { for: "t3RequiredTenure" }, "Tier 3 required tenure (sec):", -1)
const _hoisted_32 = { class: "nes-field mb-5" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("label", { for: "amount" }, "Amount (total tokens):", -1)
const _hoisted_34 = { class: "nes-field mb-5" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "duration" }, "Duration (sec):", -1)
const _hoisted_36 = { class: "flex mb-5" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "nes-btn is-primary mr-5"
}, "Fund", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _withDirectives(_createElementVNode("select", {
        required: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedReward) = $event))
      }, _hoisted_7, 512), [
        [_vModelSelect, _ctx.selectedReward]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.activeRewardType), 1)
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.fundReward && _ctx.fundReward(...args)), ["prevent"]))
    }, [
      (_ctx.activeRewardType === 'fixed')
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  id: "baseRate",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.baseRate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.baseRate]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  id: "denominator",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.denominator) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.denominator]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _hoisted_19,
                _withDirectives(_createElementVNode("input", {
                  id: "t1RewardRate",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.t1RewardRate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.t1RewardRate]
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _withDirectives(_createElementVNode("input", {
                  id: "t1RequiredTenure",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.t1RequiredTenure) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.t1RequiredTenure]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _withDirectives(_createElementVNode("input", {
                  id: "t2RewardRate",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.t2RewardRate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.t2RewardRate]
                ])
              ]),
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                _withDirectives(_createElementVNode("input", {
                  id: "t2RequiredTenure",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.t2RequiredTenure) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.t2RequiredTenure]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _withDirectives(_createElementVNode("input", {
                  id: "t3RewardRate",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.t3RewardRate) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.t3RewardRate]
                ])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _hoisted_31,
                _withDirectives(_createElementVNode("input", {
                  id: "t3RequiredTenure",
                  type: "text",
                  class: "nes-input",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.t3RequiredTenure) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.t3RequiredTenure]
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _withDirectives(_createElementVNode("input", {
          id: "amount",
          type: "text",
          class: "nes-input",
          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.amount) = $event))
        }, null, 512), [
          [_vModelText, _ctx.amount]
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _hoisted_35,
        _withDirectives(_createElementVNode("input", {
          id: "duration",
          type: "text",
          class: "nes-input",
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.duration) = $event))
        }, null, 512), [
          [_vModelText, _ctx.duration]
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _hoisted_37,
        _createElementVNode("button", {
          type: "button",
          class: "nes-btn is-error mr-5",
          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.cancelReward && _ctx.cancelReward(...args)))
        }, " Cancel "),
        _createElementVNode("button", {
          type: "button",
          class: "nes-btn is-warning",
          onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.lockReward && _ctx.lockReward(...args)))
        }, " Lock ")
      ])
    ], 32)
  ]))
}